import { CreateRecallGrooveTicket } from "components/page-components/Groove"
import React from "react"

export const CreateGrooveRecallModal = ({
  recallModal,
  toggleRecallModal,
  segment,
}) => {
  return (
    <div className={`modal ${recallModal && "is-active"}`}>
      <div
        className="modal-background"
        aria-label="close modal"
        role="button"
        tabIndex={-1}
        onKeyDown={() => {}}
        onClick={toggleRecallModal}
      ></div>
      <div className="modal-content">
        <div className="box" style={{ maxWidth: 800, margin: "0 auto" }}>
          <p className="title is-4 mb-2">Bitte rufen Sie mich zurück:</p>
          <hr className="is-mitternachtsblau-30 my-3" />

          <CreateRecallGrooveTicket {...{ segment: "ausschreibungsdienste" }} />

          <div className="mt-4">
            <button
              className="button is-sonnengelb ml-auto"
              aria-label="delete"
              onClick={toggleRecallModal}
            >
              <b>Schließen</b>
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
